import { useCallback, useEffect, useState } from 'react';
import { safeLocalStorageGetItem, safeLocalStorageSetItem } from '../utils/safeStorage';

type ForgeTheme = 'dark' | 'light';

const STORAGE_KEY = 'forge-theme';

function getPreferred(): ForgeTheme {
  const stored = safeLocalStorageGetItem(STORAGE_KEY);
  if (stored === 'dark' || stored === 'light') return stored;
  return window.matchMedia('(prefers-color-scheme: light)').matches ? 'light' : 'dark';
}

export function useForgeTheme() {
  const [theme, setTheme] = useState<ForgeTheme>(getPreferred);

  useEffect(() => {
    safeLocalStorageSetItem(STORAGE_KEY, theme);
  }, [theme]);

  const toggleTheme = useCallback(() => {
    setTheme((t) => (t === 'dark' ? 'light' : 'dark'));
  }, []);

  return { theme, toggleTheme } as const;
}
